import { COMMUNICATION_CONFIG } from '../generic';

const AUTH = {
  RESTRICT_ACCESS:
    'Unable to access for now. Please Try Later. Sorry for inconvenience.',
  CODE_RETRIES_LIMIT_REACHED: `${COMMUNICATION_CONFIG.CODE_RETRIES_LIMIT} unsuccessful attempts were made to Sign-in to your account. Access to your account is restricted.`,
  CODE_RETRIES: (retryNumber: number): string =>
    `Incorrect code. ${COMMUNICATION_CONFIG.CODE_RETRIES_LIMIT - retryNumber} ${
      COMMUNICATION_CONFIG.CODE_RETRIES_LIMIT - retryNumber === 1
        ? 'try'
        : 'tries'
    } remaining.`,
  ACCOUNT_UNDER_REVIEW:
    'We are reviewing your account. We will get back to you soon.',
  NO_TERMS_CONDITION_STATUS:
    'Please accept the Terms of Service and Privacy Policy to continue.',
} as const;

export default AUTH;
